module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "image-content-wrapper"
  }, [(_vm.isCanceled) ? _c('div', {
    staticClass: "live-video-meta rec active"
  }, [_vm._v("Avlyst!")]) : _vm._e(), _vm._v(" "), (_vm.isPostponed) ? _c('div', {
    staticClass: "live-video-meta rec active"
  }, [_vm._v("Utsatt!")]) : _vm._e(), _vm._v(" "), (_vm.time) ? _c('div', {
    staticClass: "live-video-meta time active"
  }, [_vm._v(_vm._s(_vm.timeValue))]) : _vm._e(), _vm._v(" "), (_vm.live) ? _c('div', {
    staticClass: "live-video-meta live active"
  }, [_vm._v("Direkte")]) : _vm._e(), _vm._v(" "), (_vm.rec) ? _c('div', {
    staticClass: "live-video-meta rec active"
  }, [_vm._v("Avsluttet")]) : _vm._e(), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.imageSrc,
      "alt": _vm.imageAlt,
      "title": _vm.imageAlt
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-64f4e55c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Top/TopImageBoxContent.vue
// module id = 102
// module chunks = 1